import { getChatInitialState } from '../constants';
import { TChatCardAction } from '../actions/types';
import { AT_UPDATE } from '../actions/constants';
import { IChat } from '../../../../../../../rest/effects/chats/chat/types';

const initialState: IChat = getChatInitialState();

export const chatReducer = (
    state = initialState,
    action: TChatCardAction,
): IChat => {
    switch (action.type) {
        case AT_UPDATE: {
            return {
                ...state,
                ...action.chat,
            }
        }
        default:
            return state;
    }
};
